import { render, staticRenderFns } from "./CabinetBarChart.vue?vue&type=template&id=46b3662e&scoped=true&"
import script from "./CabinetBarChart.vue?vue&type=script&lang=js&"
export * from "./CabinetBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b3662e",
  null
  
)

export default component.exports